import React, { useCallback } from 'react';
import { Modal } from 'ui-kit';
import { message } from 'antd';
import BasePayoutMethodForm from './BasePayoutMethodForm';
import { createStripeAccount } from 'api/payout_method_sdk';

interface IAddPayoutMethodModal {
  visible: boolean;
  handleClose: () => void;
}

const AddPayoutMethodModal = ({ visible, handleClose }: IAddPayoutMethodModal) => {
  const onSubmit = useCallback(
    ({ nickname, country }) =>
      createStripeAccount({ nickname, country })
        .then(({ url }) => (window.location.href = url))
        .catch((e) => message.error(e.message)),
    [],
  );

  return (
    <Modal
      className="AddPayoutMethodModal"
      visible={visible}
      footer={null}
      destroyOnClose
      onCancel={handleClose}
    >
      <BasePayoutMethodForm mode="create" type="STRP" onSubmit={onSubmit} />
    </Modal>
  );
};

export default AddPayoutMethodModal;
